import React from "react";
import { Empty } from 'antd';

class NonExistentPage extends React.Component {

    render() {
        return (
            <Empty />
        );
    }
}

export default NonExistentPage;
